import { useFormat } from '@ideavivat/vivat-2';

import { target_date } from './receive-item-with-amount';

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
    },
    description: {
      name: 'วัสดุ',
      width: '1fr',
    },
    amount: {
      name: 'จำนวนที่สั่ง',
      width: '8rem',
      filter: (val: string) => parseFloat(val).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    filledAmount: {
      name: 'จำนวนที่ได้รับแล้ว',
      width: '8rem',
      filter: (val: string) => parseFloat(val).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    addedAmount: {
      name: 'จำนวนที่รับ',
      width: '8rem',
      filter: (val: string) => parseFloat(val).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    unit: {
      name: 'หน่วย',
      width: '6rem',
      class: 'text-left',
    },
    target_date,
    created_at: {
      name: 'วันทำรายการ',
      width: '12rem',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDateTime() : '',
    },
  },
};
